import { createContext, useContext, useState, useCallback, useRef } from "react";
import { LOADING_SAFETY_TIMEOUT } from "../constants/Constants";

const CommonLoadingContext = createContext({
  isCommonLoading: false,
  setCommonLoading: () => {},
  doCommonLoading: false,
  setDoCommonLoading: () => {},
});

export const CommonLoadingProvider = ({ children }) => {
  const [isCommonLoading, _setIsCommonLoading] = useState(false);
  const [doCommonLoading, _setDoCommonLoading] = useState(false);

  // タイマーの ID を保持する (再レンダリングでリセットされない)
  const timerRef = useRef(null);
  const doTimerRef = useRef(null);

  const setCommonLoading = useCallback((loading) => {
    if (timerRef.current) clearTimeout(timerRef.current);

    if (loading === false) {
      _setIsCommonLoading(false);
    } else {
      _setIsCommonLoading(loading);

      // n秒経っても消えなかったら強制終了
      timerRef.current = setTimeout(() => {
        _setIsCommonLoading(false);
        timerRef.current = null;
      }, LOADING_SAFETY_TIMEOUT);
    }
  }, []);

  const setDoCommonLoading = useCallback((loading) => {
    if (doTimerRef.current) clearTimeout(doTimerRef.current);

    if (loading === false) {
      _setDoCommonLoading(false);
    } else {
      _setDoCommonLoading(loading);

      // n秒経っても消えなかったら強制終了
      doTimerRef.current = setTimeout(() => {
        _setDoCommonLoading(false);
        doTimerRef.current = null;
      }, LOADING_SAFETY_TIMEOUT);
    }
  }, []);

  return (
    <CommonLoadingContext.Provider
      value={{ isCommonLoading, setCommonLoading, doCommonLoading, setDoCommonLoading }}
    >
      {children}
    </CommonLoadingContext.Provider>
  );
};

export const useCommonLoading = () => useContext(CommonLoadingContext);
